import type { FC } from 'react';
import React from 'react';
import { useIntl } from 'react-intl-next';

import SectionMessage from '@atlaskit/section-message/section-message';

import { ErrorDisplay } from '@confluence/error-boundary';

import { i18n } from './SpaceCustomContentListView-i18n';

export const CustomContentErrorMessage: FC<{ error: Error }> = ({ error }) => {
	const intl = useIntl();
	return (
		<ErrorDisplay error={error}>
			<SectionMessage appearance="error" title={intl.formatMessage(i18n.errorTitle)}>
				{intl.formatMessage(i18n.errorBody)}
			</SectionMessage>
		</ErrorDisplay>
	);
};
